



























import Vue, { PropType } from 'vue';
import { CourseraCourse } from '~/models/coursera';
import CourseCard from './CourseCard.vue';

const CARD_SPACING = 30;

export default Vue.extend({
    name: 'CourseCarousel',
    components: {
        CourseCard,
    },
    props: {
        courses: {
            type: Array as PropType<CourseraCourse[]>,
            required: true,
        },
    },
    data() {
        return {
            isMounted: false,
            page: 0,
        };
    },
    computed: {
        cardsPerPage(): number {
            return this.$device.mobile ? 1 : 4;
        },
        numPages(): number {
            return Math.ceil(this.courses.length / this.cardsPerPage);
        },
        hasPrevPage(): boolean {
            return this.page > 0;
        },
        hasNextPage(): boolean {
            return this.page < this.numPages - 1;
        },
        cardWidth(): number {
            if (!this.isMounted) return 0;

            const scroller = this.$refs.scroller as Element;
            if (!scroller) return 0;

            const width = scroller.clientWidth || 1200;
            return (width - CARD_SPACING * 3) / this.cardsPerPage;
        },
    },
    methods: {
        goPrev() {
            if (!this.hasPrevPage) return;
            --this.page;
            this.doScroll();
        },
        goNext() {
            if (!this.hasNextPage) return;
            ++this.page;
            this.doScroll();
        },
        doScroll() {
            const scroller = this.$refs.scroller as Element;
            if (!scroller) return;

            const width = scroller.clientWidth;
            scroller.scrollTo({
                left: this.page * (width + CARD_SPACING / 2),
            });
        },
        handleCourseClick(course: CourseraCourse) {
            this.$emit('open-course', course);
        },
    },
    mounted() {
        this.isMounted = true;
    },
});
